import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridOptions, ColDef } from 'ag-grid-community';
import { KitInventoryStorage } from '../../investigator/kitinventory/kit-inventory-storage';
import { Observable, of, combineLatest, BehaviorSubject } from 'rxjs';
import { publishReplay, refCount, switchMap, map } from 'rxjs/operators';
import { SponsorStudyKitReport } from './sponsor-study-kit-report';
import { SponsorRouteData } from '../sponsor-route-data';
import { MdlDialogService } from '@angular-mdl/core';
import { CovanceFilter, FilterFieldValue, SerializedFilter } from '../../covance-filter';
import { KitInventoryColumns } from '../../investigator/kitinventory/kit-inventory-columns';

@Component({
    selector: 'sponsor-kit-inventory-onhand',
    template: require('./sponsor-kit-inventory-onhand.component.html'),
    styles: [require('./sponsor-kit-inventory-onhand.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorKitInventoryOnHandComponent {

    public columns: ColDef[];
    public kitReports$: Observable<SponsorStudyKitReport[]>;
    public filterFields$: Observable<FilterFieldValue[]>;
    public gridOptions: GridOptions;
    //public mandatoryMessage: Observable<boolean>;
    public filtersExportData: Observable<SerializedFilter[]>;
    public quickSearchSubject$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
        private readonly routeData: SponsorRouteData,
        private kitInventoryColumns: KitInventoryColumns,
        private kitInventoryStorage: KitInventoryStorage,
        private readonly dialogService: MdlDialogService,
        private readonly filterService: CovanceFilter
    ) {
        this.columns = this.kitInventoryColumns.sponsorColumnsOnHand;

        this.filterFields$ = this.kitInventoryStorage.loadSponsorFilterItems(routeData.snapshot.selectedStudy.protocolId).pipe(
            map(filterItems => {
                const filterDefs: FilterFieldValue[] = this.kitInventoryColumns.onHandReportfilterDefinitions;
                this.filterService.setFiltersItems(filterItems, filterDefs);
                return filterDefs;
            }),
            publishReplay(1),
            refCount());

        const filterFlow$ = this.filterFields$
            .pipe(
                switchMap(fields => this.filterService.listen(fields).pipe(map(() => fields))),
                publishReplay(1),
                refCount()
            );
         
        this.kitReports$ = filterFlow$
            .pipe(
                switchMap((fields) => {
                    this.showLoadingOverlay();
                    return this.kitInventoryStorage.getKitReports(routeData.snapshot.selectedStudy, fields);
                    //if (fields[1].queryParamValue) {
                    //    this.mandatoryMessage = of(false);
                    //    return this.kitInventoryStorage.getKitReports(routeData.snapshot.selectedStudy, fields);
                    //} else {
                    //    this.mandatoryMessage = of(true);
                    //    return of([]);
                    //}
                    
                }),
                publishReplay(1),
                refCount()
            ) as Observable<SponsorStudyKitReport[]>;

        this.gridOptions = {
            rowHeight: 35,
        };

        this.filtersExportData = combineLatest([filterFlow$, this.quickSearchSubject$])
            .pipe(
                map(([fieldValues, quickSearchValue]) => {
                    const filtersExportData = this.filterService.serializeFieldValues(fieldValues);
                    filtersExportData.unshift({ title: 'Search', value: quickSearchValue });

                    return filtersExportData;
                }),
            );
    }

    public showHelpModal() {
        var helpText = this.kitInventoryStorage.getHelpText();

        this.dialogService.alert(helpText, 'Close', 'Column Descriptions');
    }

    public onQuickSearchChanged(value: string) {
        this.quickSearchSubject$.next(value);
    }

    private showLoadingOverlay() {
        if (this.gridOptions && this.gridOptions.api) {
            this.gridOptions.api.showLoadingOverlay();
        }
    }

}